// import echarts
import * as echarts from 'echarts';
import macarons from "./macarons";

echarts.registerTheme('macarons', macarons);

// console.debug("ECharts theme registered.");